// src/components/NotificationService.js
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const notify = (message, type = "info") => {
  toast[type](message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnFocusLoss:false,
    pauseOnHover: true,
    draggable: true,
    // theme: "dark",
    // transition: "Zoom",
    // progress: undefined,
    className:"PopUpAlert"
  });
};

export default notify;
